// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as AuthVm$PorterinFeature from "../../../view-model/AuthVm.mjs";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as CustomerNameModuleScss from "../../styles/CustomerName.module.scss";

var styles = CustomerNameModuleScss;

function CustomerNameCmp(Props) {
  var name = Props.name;
  return React.createElement("div", {
              className: styles["customer-name"]
            }, React.createElement("div", {
                  className: styles.icon
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: AuthVm$PorterinFeature.profile_icon_black.src,
                      height: AuthVm$PorterinFeature.profile_icon_black.height,
                      width: AuthVm$PorterinFeature.profile_icon_black.width,
                      quality: 70.0,
                      alt: AuthVm$PorterinFeature.profile_icon_black.alt
                    })), React.createElement("p", {
                  className: styles.name
                }, name));
}

var make = CustomerNameCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
